import api from './api';

const hrService = {
  // Employees
  getAllEmployees: async () => {
    const response = await api.get('/api/hr/employees');
    return response.data;
  },
  getEmployeesByModule: async (module) => {
    const response = await api.get(`/api/hr/employees/module/${module}`);
    return response.data;
  },
  getEmployeeById: async (id) => {
    const response = await api.get(`/api/hr/employees/${id}`);
    return response.data;
  },
  getEmployeeFullLedger: async (id, startDate, endDate) => {
    let url = `/api/hr/employees/${id}/ledger`;
    if (startDate && endDate) url += `?start_date=${startDate}&end_date=${endDate}`;
    const response = await api.get(url);
    return response.data;
  },
  createEmployee: async (data) => {
    const response = await api.post('/api/hr/employees', data);
    return response.data;
  },
  updateEmployee: async (id, data) => {
    const response = await api.put(`/api/hr/employees/${id}`, data);
    return response.data;
  },
  deleteEmployee: async (id) => {
    const response = await api.delete(`/api/hr/employees/${id}`);
    return response.data;
  },

  // Advances
  getAllAdvances: async () => {
    const response = await api.get('/api/hr/advances');
    return response.data;
  },
  getAdvancesByEmployee: async (id) => {
    const response = await api.get(`/api/hr/advances/employee/${id}`);
    return response.data;
  },
  createAdvance: async (data) => {
    const response = await api.post('/api/hr/advances', data);
    return response.data;
  },
  deleteAdvance: async (id) => {
    const response = await api.delete(`/api/hr/advances/${id}`);
    return response.data;
  },

  // Salaries
  getAllSalaries: async () => {
    const response = await api.get('/api/hr/salaries');
    return response.data;
  },
getProRataForSalary: async (employeeId, month, year) => {
    const response = await api.get(`/api/hr/salaries/prorata?employee_id=${employeeId}&month=${month}&year=${year}`);
    return response.data;
  },

  getSalariesByEmployee: async (id) => {
    const response = await api.get(`/api/hr/salaries/employee/${id}`);
    return response.data;
  },
  createSalary: async (data) => {
    const response = await api.post('/api/hr/salaries', data);
    return response.data;
  },
  deleteSalary: async (id) => {
    const response = await api.delete(`/api/hr/salaries/${id}`);
    return response.data;
  },

  // Attendance
  getAllAttendanceByDate: async (date) => {
    const response = await api.get(`/api/hr/attendance?date=${date}`);
    return response.data;
  },
  markAttendance: async (data) => {
    const response = await api.post('/api/hr/attendance', data);
    return response.data;
  },

  // Permanent Loans
  getAllPermanentLoans: async () => {
    const response = await api.get('/api/hr/permanent-loans');
    return response.data;
  },
  getPermanentLoansByEmployee: async (id) => {
    const response = await api.get(`/api/hr/permanent-loans/employee/${id}`);
    return response.data;
  },
  createPermanentLoan: async (data) => {
    const response = await api.post('/api/hr/permanent-loans', data);
    return response.data;
  },
  settlePermanentLoan: async (id) => {
    const response = await api.put(`/api/hr/permanent-loans/${id}/settle`);
    return response.data;
  },
  deletePermanentLoan: async (id) => {
    const response = await api.delete(`/api/hr/permanent-loans/${id}`);
    return response.data;
  },
// Module Allocations
  getEmployeeAllocations: async (id) => {
    const response = await api.get(`/api/hr/employees/${id}/allocations`);
    return response.data;
  },
  setEmployeeAllocations: async (id, allocations) => {
    const response = await api.put(`/api/hr/employees/${id}/allocations`, { allocations });
    return response.data;
  },
  getProRataForSalary: async (employeeId, month, year) => {
    const response = await api.get(`/api/hr/salaries/prorata?employee_id=${employeeId}&month=${month}&year=${year}`);
    return response.data;
  },

};

export default hrService;